"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var dayjs_1 = __importDefault(require("dayjs"));
var api_1 = __importDefault(require("api"));
var QueriesStore_1 = require("stores/QueriesStore");
var Notification_1 = require("components/core/Notification");
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var TextInput_1 = __importDefault(require("components/core/inputs/TextInput"));
var UserStore_1 = require("../../../../../stores/UserStore");
var InfoRow_1 = __importDefault(require("../../../../core/common/InfoRow"));
var Button_1 = __importDefault(require("../../../../core/buttons/Button"));
var Select_1 = __importDefault(require("../../../../core/inputs/Select"));
var Dialog_1 = require("../../../../core/Dialog");
var use_dialog_1 = require("../../../../../hooks/use-dialog");
var toBoolean = function (input) { return input === "true"; };
var PODQueryStage4 = function (_a) {
    var data = _a.data;
    var _b = use_stores_1.useStores(), userStore = _b.userStore, queriesStore = _b.queriesStore;
    var timeout = react_1.useRef("");
    var notification = use_notification_1.useNotification();
    var history = react_router_dom_1.useHistory();
    var dialog = use_dialog_1.useDialog();
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        if (value === "true" || value === "false")
            value = toBoolean(value);
        api_1.default.patchQuery(data.id, (_a = {},
            _a[e.currentTarget.name] = value,
            _a))
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query successfully updated"
            });
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        });
    };
    var keyHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        if (timeout.current !== null)
            clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            var _a;
            api_1.default.patchQuery(data.id, (_a = {},
                _a[name] = value,
                _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query successfully updated"
                });
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error updating query"
                });
            });
        }, 500);
    };
    var completeHandler = function () {
        if (data.podQuery.creditDate === null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please enter the Credit Date"
            });
            return;
        }
        if (data.dateCompleted === null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please enter the Completed Date"
            });
            return;
        }
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Complete this query?",
            description: "Are you sure you want to complete this query? Please make sure all details are correct and leave your comments below.",
            withComment: true,
            queryId: data.id,
            stage: 4,
            direction: "Forward"
        })
            .then(function (response) {
            api_1.default.sendQueryForward(data.id, { currentStage: 4 })
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query completed!"
                });
                setTimeout(function () {
                    history.replace("/");
                }, 1000);
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Query could not be completed due to an error"
                });
            });
        });
    };
    return (react_1.default.createElement("div", { className: "pod-query-stage-4" },
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "half" },
                data.queryStage.stage === 4 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_4) ?
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "creditNoteRef", defaultValue: data.podQuery.creditNoteRef, onKeyUp: keyHandler })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Credit Note Ref", value: data.podQuery.creditNoteRef }),
                data.queryStage.stage === 4 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_4) ?
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "invoiceNumber", defaultValue: data.podQuery.invoiceNumber, onKeyUp: keyHandler })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Invoice Number", value: data.podQuery.invoiceNumber }),
                data.queryStage.stage === 4 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_4) ?
                    react_1.default.createElement(Select_1.default, { name: "queryResult", value: data !== null && data.podQuery.queryResult || "", options: Object.keys(QueriesStore_1.PODQueryResults).map(function (type) { return ({
                            value: QueriesStore_1.PODQueryResults[type],
                            text: QueriesStore_1.PODQueryResults[type]
                        }); }), onChange: changeHandler })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Query Result", value: data.podQuery.queryResult })),
            react_1.default.createElement("div", { className: "half" },
                data.queryStage.stage === 4 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_4) ?
                    react_1.default.createElement(TextInput_1.default, { type: "date", name: "creditDate", value: data.podQuery.creditDate && dayjs_1.default(data.podQuery.creditDate).format("YYYY-MM-DD") || null, onChange: changeHandler })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Credit Note Date", value: dayjs_1.default(data.podQuery.creditDate).format("DD/MM/YYYY") }),
                data.queryStage.stage === 4 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_4) ?
                    react_1.default.createElement(TextInput_1.default, { type: "date", name: "dateCompleted", value: data.dateCompleted && dayjs_1.default(data.dateCompleted).format("YYYY-MM-DD") || null, onChange: changeHandler })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Date Completed", value: dayjs_1.default(data.dateCompleted).format("DD/MM/YYYY") }))),
        data.queryStage.stage === 4 &&
            userStore.hasPermission(UserStore_1.Permissions.STAGE_4) &&
            react_1.default.createElement(Button_1.default, { type: "button", onClick: completeHandler, title: "Complete Query" }, "Complete Query")));
};
exports.default = PODQueryStage4;
